import { render } from "./AddProduct.vue?vue&type=template&id=1989afed&scoped=true"
import script from "./AddProduct.vue?vue&type=script&lang=js"
export * from "./AddProduct.vue?vue&type=script&lang=js"

import "./AddProduct.vue?vue&type=style&index=0&id=1989afed&lang=scss"
import "./AddProduct.vue?vue&type=style&index=1&id=1989afed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1989afed"]])

export default __exports__